export const isMasScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "mas";

const LIMB_KEYS = [
  "upper_left_limb",
  "lower_left_limb",
  "upper_right_limb",
  "lower_right_limb",
];

export const hasMasAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of LIMB_KEYS) {
    const v = data[k];
    if (v == null || v === "") continue;
    if (typeof v === "string" && v.trim() !== "") return true;
    if (typeof v === "number" && Number.isFinite(v)) return true;
  }

  return false;
};

